import { useEffect, useState } from "react";
import { api } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";

export default function MissionsManager() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const { data } = await api.get("/admin/missions");
    setItems(data || []);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const upd = (id, k, v) => setItems((p) => p.map((x) => x.id === id ? { ...x, [k]: v } : x));

  const save = async (m) => {
    try {
      await api.put(`/admin/missions/${m.id}`, {
        slug: m.slug, name: m.name, event: m.event, points: Number(m.points) || 0,
        active: m.active !== false, sort_order: Number(m.sort_order) || 0, icon: m.icon || "",
      });
      toast.success("Saved");
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const add = async () => {
    const slug = prompt("Mission slug:");
    if (!slug) return;
    const event = prompt("Event name (must match a reward rule event like share/music_play):");
    if (!event) return;
    try {
      const { data } = await api.post("/admin/missions", {
        slug, name: slug, event, points: 10, active: true, sort_order: items.length + 1, icon: "◆",
      });
      setItems((p) => [...p, data]);
      toast.success("Created");
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete this mission?")) return;
    await api.delete(`/admin/missions/${id}`);
    setItems((p) => p.filter((x) => x.id !== id));
  };

  if (loading) return <div className="text-white/40">Loading…</div>;
  return (
    <div className="space-y-4" data-testid="missions-manager">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="font-heading text-2xl text-white tracking-wider">Daily Missions</h2>
          <p className="text-white/40 text-xs mt-1">Reset every day. Completing awards points via the rewards engine.</p>
        </div>
        <button onClick={add} data-testid="add-mission-btn" className="text-xs bg-[#D4AF37] text-black px-4 py-2 hover:bg-white uppercase tracking-widest flex items-center gap-2">
          <Plus className="w-3.5 h-3.5" /> Add
        </button>
      </div>
      <div className="grid gap-2">
        {items.map((m) => (
          <div key={m.id} className="bg-[#0A0A0A] border border-white/5 rounded p-3 grid md:grid-cols-7 gap-2 items-center" data-testid={`mission-row-${m.slug}`}>
            <input className="input-dark" value={m.icon || ""} placeholder="Icon" onChange={(e) => upd(m.id, "icon", e.target.value)} />
            <input className="input-dark md:col-span-2" value={m.name} placeholder="Name" onChange={(e) => upd(m.id, "name", e.target.value)} />
            <input className="input-dark" value={m.event} placeholder="event" onChange={(e) => upd(m.id, "event", e.target.value)} />
            <input className="input-dark" type="number" value={m.points} placeholder="Points" onChange={(e) => upd(m.id, "points", e.target.value)} />
            <input className="input-dark" type="number" value={m.sort_order || 0} placeholder="Order" onChange={(e) => upd(m.id, "sort_order", e.target.value)} />
            <div className="flex gap-1 justify-end">
              <button onClick={() => save(m)} className="text-xs bg-[#D4AF37] text-black p-2 hover:bg-white"><Save className="w-3.5 h-3.5" /></button>
              <button onClick={() => del(m.id)} className="text-xs text-red-400 hover:text-red-300 p-2"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
      <style>{`.input-dark { background:#000; border:1px solid rgba(255,255,255,0.1); color:#fff; padding:8px 10px; font-size:12px; border-radius:4px; outline:none; } .input-dark:focus { border-color:#D4AF37; }`}</style>
    </div>
  );
}
